var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVolumeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.682 8.693c1.584 2.514 1.808 5.86.301 8.822m-3.637-7.178c1.337 1.563 1.526 3.643.254 5.483M12 6.613l-4.412 3.489H3v5.022h4.588L12 18.613v-12z",
    stroke: "#10121C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVolumeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/VolumeIcon.9f1fe40d.svg";
export { ForwardRef as ReactComponent };